import { render, staticRenderFns } from "./chatBalloon.vue?vue&type=template&id=397a6c89&scoped=true&"
import script from "./chatBalloon.vue?vue&type=script&lang=ts&"
export * from "./chatBalloon.vue?vue&type=script&lang=ts&"
import style0 from "./chatBalloon.vue?vue&type=style&index=0&id=397a6c89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a6c89",
  null
  
)

export default component.exports